import * as React from "react"
import LazyImage from "../general/lazyImage"
import Translate from '../general/translate'

const InterfaceExplanation = () => {

  return (    
    <div className="pt-20 pb-20 bg-[#643ADA]">
        <div className="w-5/6 m-auto">
            <h3 className="text-center text-md leading-tight font-extrabold text-white opacity-60 tracking-wide mb-8">
                <Translate id="more.resources.label" foldername="home" filename="home-blogsection" />
            </h3>
            <h2 className="text-center leading-tight text-3xl lg:text-5xl text-[#F3F3F1] font-bold mb-20">
                <Translate id="learn.how.to.get.most" foldername="home" filename="home-blogsection" /> 
                <span className="text-[#FFCA1D] font-extrabold"> <Translate id="your.content" foldername="home" filename="home-blogsection" /> </span>
            </h2>
        </div>
        <div className="w-5/6 md:w-1/2 lg:w-5/6 m-auto text-center">
            <div className="mx-auto grid grid-cols-1 lg:grid-cols-3 gap-6 pb-0">
                <a href="/blog/podsqueeze-onboarding-ai-shownotes-podcast" className="col-span-1 p-2 cursor-pointer">
                    <div className="bg-white h-[420px] p-0 rounded-2xl">
                        <LazyImage src="/blog/covers/onboardingebook.webp" alt="Podsqueeze onboarding ebook" className="rounded-t-2xl h-auto" />
                        <p className="text-2xl font-bold mb-2 px-8 pt-8 pb-1 text-left text-[#27004F]">
                            <Translate id="get.most.out.of.ai.content" foldername="home" filename="home-blogsection" />
                        </p>
                        <p className="text-md leading-tight px-8 pt-1 pb-10 text-left mb-5 text-[#27004F]">
                            <Translate id="welcome.to.podsqueeze" foldername="home" filename="home-blogsection" />
                        </p>
                    </div>
                </a>
                <a href="/blog/will-google-penalize-ai-content" className="col-span-1 p-2 cursor-pointer">
                    <div className="bg-white h-[420px] p-0 rounded-2xl">
                        <LazyImage src="/blog/covers/googleai.webp" alt="Ai content SEO" className="rounded-t-2xl h-auto" />
                        <p className="text-2xl font-bold text-[#27004F] mb-2 px-8 pt-8 pb-1 text-left">
                            <Translate id="will.google.penalize.ai.content" foldername="home" filename="home-blogsection" />
                        </p>
                        <p className="text-md px-8 pt-1 pb-10 text-left text-[#27004F]">
                            <Translate id="ai.content.discussion" foldername="home" filename="home-blogsection" />
                        </p>
                    </div>
                </a>
                <a href="/blog/what-is-and-how-to-use-rss-feed" className="col-span-1 p-2 cursor-pointer">
                    <div className="bg-white h-[420px] p-0 rounded-2xl">
                        <LazyImage src="/blog/covers/whatisrss.webp" alt="What is an RSS feed for podcasts" className="rounded-t-2xl h-auto" />
                        <p className="text-2xl font-bold mb-2 px-8 pt-8 text-[#27004F] pb-1 text-left">
                            <Translate id="what.is.rss.feed" foldername="home" filename="home-blogsection" />
                        </p>
                        <p className="text-md px-8 pt-1 pb-10 text-left text-[#27004F]">
                            <Translate id="rss.feed.benefits" foldername="home" filename="home-blogsection" />
                        </p>
                    </div>
                </a>
            </div>
            <a href="/blog" className="inline-block bg-[#FFCA1D] text-[#483187] mt-10 font-bold text-xl px-8 py-4 rounded-[8px] shadow hover:shadow-lg no-underline focus:no-underline text-center m-auto">
                <Translate id="visit.blog" foldername="home" filename="home-blogsection" />
            </a>
        </div>
    </div>
  )
}

export default InterfaceExplanation